import { memo } from 'react';

import { usePrivateWorkspaceAgentGuidedVariantMediaSelection } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/usePrivateWorkspaceAgentGuidedVariantMediaSelection';
import { usePrivateWorkspaceAgentSmartResizeSavedCatalog } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/usePrivateWorkspaceAgentSmartResizeSavedCatalog';
import { WorkspaceAgentGuidedVariantSmartResizeSettings } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantSmartResizeSettings';
import { type WorkspaceAgentGuidedVariantGenerateRequest } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/workspaceAgentGuidedVariantGenerateRequest';

export type PrivateWorkspaceAgentGuidedVariantSmartResizeSettingsProps = {
  onGenerate: (request: WorkspaceAgentGuidedVariantGenerateRequest) => void;
};

export const PrivateWorkspaceAgentGuidedVariantSmartResizeSettings = memo(
  ({ onGenerate }: PrivateWorkspaceAgentGuidedVariantSmartResizeSettingsProps) => {
    const mediaSelection = usePrivateWorkspaceAgentGuidedVariantMediaSelection();
    const savedCatalog = usePrivateWorkspaceAgentSmartResizeSavedCatalog();

    return (
      <WorkspaceAgentGuidedVariantSmartResizeSettings
        imageCount={mediaSelection.mediaCount}
        onGenerate={onGenerate}
        savedCatalog={savedCatalog}
        skippedFileCount={mediaSelection.skippedFileCount}
      />
    );
  },
);

PrivateWorkspaceAgentGuidedVariantSmartResizeSettings.displayName =
  'PrivateWorkspaceAgentGuidedVariantSmartResizeSettings';
